import { render } from "./Cog.vue?vue&type=template&id=71056a99"
const script = {}

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__